import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupModule } from '@rd/popup/popup.module';
import { StarNoticeModalService } from '../../services/notice-modal/notice-modal.service';

@Component({
  selector: 'star-core-notice-modal',
  templateUrl: './notice-modal.component.html',
  styleUrls: ['./notice-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PopupModule, TranslateModule],
})
export class StarNoticeModalComponent {
  @HostBinding('class.star-core-notice-modal') componentClass = true;

  private readonly dialogRef = inject(DialogRef);
  private readonly noticeModalService = inject(StarNoticeModalService);

  /**
   * The only way out of this dialog — it has no close button, and the overlay
   * and escape key are both disabled by the dialog config.
   */
  acknowledge(): void {
    this.noticeModalService.acknowledge();
    this.dialogRef.close();
  }
}
